// src/components/ChatPhotoViewer.js — full-screen photo view for chat images
import { useEffect } from 'react'
import { createPortal } from 'react-dom'
import './ChatThread.css'

export default function ChatPhotoViewer({ src, onClose }) {
  useEffect(() => {
    if (!src) return
    const onKey = e => { if (e.key === 'Escape') onClose() }
    document.addEventListener('keydown', onKey)
    return () => document.removeEventListener('keydown', onKey)
  }, [src, onClose])

  if (!src) return null
  // Rendered at the page root: the chat box uses a CSS transform, which would
  // otherwise trap a "fixed" full-screen layer inside it.
  return createPortal(
    <div className="chat-viewer" onClick={onClose} role="dialog" aria-modal="true">
      <button className="chat-viewer__close" onClick={onClose} aria-label="Close">✕</button>
      <img src={src} alt="Shared" className="chat-viewer__img" onClick={e => e.stopPropagation()} />
    </div>,
    document.body
  )
}
